import React, { useState, useMemo, useCallback } from 'react';

import VenuesApp from './venuesApp';
import MiceTemplate from '../miceTemplate';
import { trackClick } from 'UtilityComponents/venueUtils';

import { NavigationLinks, QUERY_BTN_TXT } from './config';

const LandingPage = (props) => {
	const { isMobileView } = props;
	const [queryForm, setQueryForm] = useState(false);

	const toggleForm = useCallback(() => {
		if (!status) {
			trackClick('query_clicked');
		}
		setQueryForm((status) => !status);
	}, []);

	const headerConfig = useMemo(() => ({
		menuWidth: 'auto',
		menus: [
			{
				btnTxt: QUERY_BTN_TXT,
				btnType: 'Flat',
				btnName: 'Primary',
				btnShadow: true,
				btnWidth: isMobileView ? false : '215px',
				height: '48px',
				handleClick: toggleForm,
				right_M: 16,
				bottom_M: 5,
				show: true
			}
		],
		showMenuOnScroll: true
	}), [isMobileView, toggleForm]);

	return (
		<MiceTemplate
			headerConfig={headerConfig}
			headerLinks={NavigationLinks}
			{...props}>
			<VenuesApp queryForm={queryForm} toggleForm={toggleForm} />
		</MiceTemplate>
	);
};

export default LandingPage;
